export default __webpack_public_path__ + "static/media/download-dark.121caeab.svg";